import angular from 'angular';
import sectionsLibraryService from './../../../SectionsLibraryService';
import toolbarService from './../../../../Toolbar/ToolbarService';
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import Backgrounds from "../../../../ConfigParameters/ConfigCollections/Backgrounds";
import Margins from "../../../../ConfigParameters/ConfigCollections/Margins";
import BackgroundButtonColor from "../../../../ConfigParameters/ConfigParameters/BackgroundButtonColor";
import Align from "../../../../ConfigParameters/ConfigParameters/Align";
import TextColor from "../../../../ConfigParameters/ConfigParameters/Color";
import ButtonText from "../../../../ConfigParameters/ConfigParameters/ButtonText";
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import Borders from "../../../../ConfigParameters/ConfigCollections/Borders";
import FontSize from "../../../../ConfigParameters/ConfigParameters/FontSize";
import FontWeight from "../../../../ConfigParameters/ConfigParameters/FontWeight";
import Analytics from "../../../../ConfigParameters/ConfigParameters/Analytics";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'pageButton';

const creatorPageSectionButton = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: require('./button.html'),
    controller: function (ToolbarService, $element, gettextCatalog) {

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        // Update language-dependent value
        defaultConfig.text = gettextCatalog.getString(defaultConfig.text);

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };


        $element.find('a').on('click', function (e) {
            e.preventDefault();
        });

    }
};

export default angular.module('cms.creator.page.section-button', [sectionsLibraryService, toolbarService])
    .run(function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

        SectionsLibraryService.registerSection({
            icon: 'add_box',
            type: MODULE_NAME,
            label: gettext('Button'),
            group: 'page',
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                borders: {
                    label: gettext('Button borders'),
                    isOpen: false,
                    type: 'borders'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                },
                analytics: {
                    label: gettext('Analytics'),
                    isOpen: false,
                    type: 'analytics'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        let textColor = new TextColor();
        textColor.setDefaultValue('#ffffff');

        let fontWeight = new FontWeight();
        fontWeight.setDefaultValue('normal');
        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(new ConfigParameter('sectionId', 'hidden', gettext('Section Id'), null, (type) => UniqueIdGenerator.generate(type))),
            ...(new ConfigParameter('uid', 'hidden', '', null, () => UniqueIdGenerator.generate('element-uid'))),
            ...(new ButtonText()),
            ...(new ConfigParameter('href', 'button-link',gettext('Link or attached file'),'mainConfig', "", null, null, null, gettext('Insert URL or pick the file.'))),
            ...(textColor),
            ...(new FontSize()),
            ...(fontWeight),
            ...(new Align()),
            ...(new BackgroundButtonColor()),
            ...(new Borders()),
            ...(new Backgrounds()),
            ...(new Paddings()),
            ...(new Margins()),
            ...(new Analytics()),
            ...(new CustomClassName())
        });

    })
    .component('cmsCreatorPageSectionButton', creatorPageSectionButton).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Button/Button.js